/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteWidgetRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'
import {DeleteWidgetResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'


export const deleteWidget = (request: DeleteWidgetRequest, options?: CashRequestOptions) => post<DeleteWidgetRequest, DeleteWidgetResponse>("/cash-app/goose-cash/v3/delete-widget", request, {...options, rejectOnError: true })